import React, {Component} from "react"
import {Link} from "react-router-dom"
import shop from "shop/shop"
import {observer} from "mobx-react"
import {Button, Icon, Popup} from "semantic-ui-react"
import settingStore from "stores/settingStore"
import Price from "components/Price/Price"
import MinOrderValue from "components/Cart/MinOrderValue"
import queryString from "qs"

@observer
export default class CartButton extends Component {

	constructor() {
		super()
		this.state = {
			sum: 0
		}
	}

	render() {
		let {sum, loading} = shop.cart
		const MIN_ORDER_VALUE = Number( shop.config.MIN_ORDER_VALUE ) || 0
		const aboveMin = !shop.config.MIN_ORDER_VALUE || (sum > shop.config.MIN_ORDER_VALUE)
		let discountSum = shop.cart.data.sum
		let discountVat = shop.cart.data.vat
		console.log("discountSum",discountSum, "discountVat",discountVat)
		if(shop.cart.activeCoupons && shop.cart.activeCoupons[0]){
			sum = discountSum
		}
		if ( !shop.session ) return null

		return (
			<div className="CartButton relative">
				<Button 
					primary
					id="cart-button"
					loading={loading}
					className=""
					{...this.props}
					as={Link}
					to={{
						pathname: `/checkout/`,
						search  : queryString.stringify( {referer: document.location.pathname} )
					}}
					// onClick={app.sidebar.toggle.dispatch}
				>
					<Popup trigger={
						<React.Fragment>
							<p className="f5 fw6">
							{aboveMin ? <Icon name="shopping basket" /> : <Icon name={"warning circle"} />}
							{sum > 0 ? <Price>{sum}</Price> : <span><Price>0</Price></span>}</p>
						</React.Fragment>
					}>

						<div>
							{!!MIN_ORDER_VALUE && <span>{translate( "min_order_value" )} <Price>{shop.config.MIN_ORDER_VALUE}</Price></span>}
							{(!MIN_ORDER_VALUE) && <span>Warenkorb anzeigen</span>}
						</div>
					</Popup>
				</Button>
				<div className="absolute left-0 right-0 MinOrderValue-container">
					{/*<MinOrderValue sum={sum} /> */}
				</div>
			</div>
		)
	}
}





// WEBPACK FOOTER //
// ./src/theme/trendimport.test/components/Cart/CartButton.js